module.exports = __webpack_public_path__ + "static/media/timer-not-save.53b7eced.png";